<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div class="text-center" v-show="loading">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
          <div slot="header">
            <strong v-text="formTitle" />
          </div>
          <b-form @submit.prevent="save" v-show="!loading">
            <b-row>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.profileLang.inquiry_type_id"
                  label-for="inquiryTypeIdSelected"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.profileLang.inquiry_type_id"
                    :rules="$v.inquiryTypeIdSelected.$params"
                  />
                  <selectFind
                    :options="inquiryTypeIdOption"
                    v-model="$v.inquiryTypeIdSelected.$model"
                    label="text"
                    :isValid="
                      $v.inquiryTypeIdSelected.$dirty
                        ? !$v.inquiryTypeIdSelected.$error
                        : null
                    "
                  />

                  <b-form-invalid-feedback
                    id="inquiryTypeIdSelected-feedback"
                    :style="{
                      display: $v.inquiryTypeIdSelected.$error
                        ? 'block'
                        : 'none',
                    }"
                  >
                    {{
                      $lang.error_required
                        | replace($lang.profileLang.inquiry_type_id)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.profileLang.inquiry_input_type_id"
                  label-for="inquiryInputTypeIdSelected"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.profileLang.inquiry_input_type_id"
                    :rules="$v.inquiryInputTypeIdSelected.$params"
                  />
                  <selectFind
                    :options="inquiryInputTypeIdOption"
                    v-model="$v.inquiryInputTypeIdSelected.$model"
                    label="text"
                    :isValid="
                      $v.inquiryInputTypeIdSelected.$dirty
                        ? !$v.inquiryInputTypeIdSelected.$error
                        : null
                    "
                  />

                  <b-form-invalid-feedback
                    id="inquiryInputTypeIdSelected-feedback"
                    :style="{
                      display: $v.inquiryInputTypeIdSelected.$error
                        ? 'block'
                        : 'none',
                    }"
                  >
                    {{
                      $lang.error_required
                        | replace($lang.profileLang.inquiry_input_type_id)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.profileLang.inquiry_result_id"
                  label-for="inquiryResultIdSelected"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.profileLang.inquiry_result_id"
                    :rules="$v.inquiryResultIdSelected.$params"
                  />
                  <selectFind
                    :options="inquiryResultIdOption"
                    v-model="$v.inquiryResultIdSelected.$model"
                    label="text"
                    :isValid="
                      $v.inquiryResultIdSelected.$dirty
                        ? !$v.inquiryResultIdSelected.$error
                        : null
                    "
                  />

                  <b-form-invalid-feedback
                    id="inquiryResultIdSelected-feedback"
                    :style="{
                      display: $v.inquiryResultIdSelected.$error
                        ? 'block'
                        : 'none',
                    }"
                  >
                    {{
                      $lang.error_required
                        | replace($lang.profileLang.inquiry_result_id)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.profileLang.inquiry_date"
                  label-for="inquiryDate"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.profileLang.inquiry_date"
                    :rules="$v.inquiryDate.$params"
                  />
                  <date-picker
                    v-model="$v.inquiryDate.$model"
                    :state="
                      $v.inquiryDate.$dirty ? !$v.inquiryDate.$error : null
                    "
                    inputReq="true"
                    @input="changeToYear($v)"
                    auto-submit
                    clearable
                    format="YYYY-MM-DD"
                    display-format="jYYYY/jMM/jDD"
                    :max="new Date() | moment('YYYY/MM/DD')"
                    :class="
                      $v.inquiryDate.$dirty
                        ? $v.inquiryDate.$error
                          ? 'invalid-date'
                          : 'valid-date'
                        : null
                    "
                  >
                  </date-picker>
                  <b-form-invalid-feedback
                    :style="{
                      display: $v.inquiryDate.$error ? 'block' : 'none',
                    }"
                    id="inquiryDate-feedback"
                  >
                    {{
                      $lang.error_required
                        | replace($lang.profileLang.inquiry_date)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12">
                <b-form-group
                  :label="$lang.profileLang.inquiry_result_text"
                  label-for="inquiryResultText"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.profileLang.inquiry_result_text"
                    :rules="$v.inquiryResultText.$params"
                  />
                  <b-form-textarea
                    id="inquiryResultText"
                    v-model="$v.inquiryResultText.$model"
                    :autocomplete="$lang.profileLang.inquiry_result_text"
                    :rows="this.$config.form.textareaRows"
                    :state="
                      $v.inquiryResultText.$dirty
                        ? !$v.inquiryResultText.$error
                        : null
                    "
                  />
                  <b-form-invalid-feedback
                    :style="{
                      display: $v.inquiryResultText.$error ? 'block' : 'none',
                    }"
                    id="inquiryResultText-feedback"
                  >
                    {{
                      $lang.error_required
                        | replace($lang.profileLang.inquiry_result_text)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12">
                <b-form-group
                  :label="$lang.description"
                  label-for="address"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.description"
                    :rules="$v.description.$params"
                  />
                  <b-form-textarea
                    id="description"
                    type="text"
                    v-model="$v.description.$model"
                    :autocomplete="$lang.description"
                    :rows="this.$config.form.textareaRows"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <div slot="footer" class="form-group form-btn">
              <b-button type="submit" size="md" variant="success">
                {{ $lang.submitButton }}
                <i class="fa fa-check"></i>
              </b-button>
              <b-button
                type="reset"
                class="ml-2"
                size="md"
                variant="danger"
                @click="closeModal()"
              >
                {{ $lang.cancelButton }}
                <i class="fa fa-ban"></i>
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { renderEumOptions } from "@/shared/utils";
import { required } from "vuelidate/lib/validators";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { pathOr } from "ramda";

export default {
  validations: {
    inquiryTypeIdSelected: {
      required,
    },
    inquiryInputTypeIdSelected: {
      required,
    },
    inquiryResultIdSelected: {
      required,
    },
    inquiryResultText: {
      required,
    },
    inquiryDate: {
      required,
    },
    description: {},
  },
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: null,
    },
    formTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      inquiryTypeIdSelected: null,
      inquiryInputTypeIdSelected: null,
      inquiryResultIdSelected: null,
      inquiryResultText: null,
      inquiryDate: null,
      description: null,
    };
  },
  computed: {
    inquiryTypeIdOption() {
      return renderEumOptions("inquiry_type");
    },
    inquiryInputTypeIdOption() {
      return renderEumOptions("inquiry_input_type");
    },
    inquiryResultIdOption() {
      return renderEumOptions("inquiry_result");
    },
  },
  watch: {
    item(value) {
      value && this.fetchData();
    },
  },
  methods: {
    changeToYear(item) {
      if (this.to_year && item.from_year.$model > this.to_year) {
        item.to_year.$model = "";
      }
    },
    closeModal() {
      this.$emit("closeModal");
    },
    save() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      const payload = {
        inquiry_type_id: pathOr(null, ["value"], this.inquiryTypeIdSelected),
        inquiry_result_id: pathOr(
          null,
          ["value"],
          this.inquiryResultIdSelected
        ),
        inquiry_input_type_id: pathOr(
          null,
          ["value"],
          this.inquiryInputTypeIdSelected
        ),
        inquiry_date: this.inquiryDate,
        description: this.description,
        inquiry_result_text: this.inquiryResultText,
      };
      this.$emit("submit", payload);
    },
    fetchData() {
      if (this.item) {
        this.inquiryTypeIdSelected = this.inquiryTypeIdOption.find(
          (x) => x.value === pathOr(null, ["inquiry_type", "id"], this.item)
        );
        this.inquiryInputTypeIdSelected = this.inquiryInputTypeIdOption.find(
          (x) =>
            x.value === pathOr(null, ["inquiry_input_type", "id"], this.item)
        );
        this.inquiryResultIdSelected = this.inquiryResultIdOption.find(
          (x) => x.value === pathOr(null, ["inquiry_result", "id"], this.item)
        );
        this.inquiryResultText = pathOr(
          null,
          ["inquiry_result_text"],
          this.item
        );
        this.inquiryDate = pathOr(
          null,
          ["inquiry_date", "gregorian"],
          this.item
        );
        this.description = pathOr(null, ["description"], this.item);
      }
    },
  },
};
</script>